/**
 * 我的首页接口
 */
export default {
  // 我的首页-我的账号-账号信息管理-查询
  common_qryAccountInfoDetail: {
    // mock: true,
    control: 'dyc/saas/common/user/qryUserAccountDetail'
  },
  // 我的首页-我的账号-账号信息管理-修改
  umc_updateUserSelf: {
    // mock: true,
    control: 'dyc/common/user/updateUserSelf'
  },
  // 我的首页-我的账号-收货地址列表查询
  common_operLogisticsRela: {
    // mock: true,
    control: 'dyc/common/user/shipAddress/operLogisticsRela'
  },
  // 我的首页-我的账号-账号安全管理-获取验证码
  umc_memAuthenticatioGetVerifyCode: {
    // mock: true,
    control: 'dyc/common/user/mem/memAuthenticatioGetVerifyCode'
  },
  // 账号安全管理
  umc_noauth_memAuthenticatioGetVerifyCode: {
    // mock: true,
    control: '/umc/users/signup/forgotPasswordCheck'
  },
  // 我的首页-我的账号-账号安全管理-身份验证
  umc_checkMemAuthenticatioVerifyCode: {
    // mock: true,
    control: 'dyc/common/user/mem/checkMemAuthenticatioVerifyCode'
  },
  // 忘记密码获取code
  umc_noauth_checkVFcode: {
    // mock: true,
    control: '/umc/users/signup/checkVFcode'
  },
  // 我的首页-我的账号-账号安全管理-身份验证-无需登录
  umc_noauth_checkMemAuthenticatioVerifyCode: {
    // mock: true,
    control: 'dyc/common/user/noauth/mem/checkMemAuthenticatioVerifyCode'
  },
  // 忘记密码验证是否有修改权限
  umc_noauth_isChangePasswordCheck: {
    // mock: true,
    control: '/dyc/saas/common/user/noauth/isChangePasswordCheck'
  },
  // 我的首页-我的账号-账号安全管理-修改手机号、邮箱获取验证码
  umc_getVerifyCode: {
    // mock: true,
    control: 'dyc/common/user/mem/memAuthenticatioGetVerifyCode '
  },
  // 我的首页-我的账号-账号安全管理-修改用户校验手机号
  umc_updateCheckUserExist: {
    // mock: true,
    control: 'dyc/common/user/mem/updateCheckUserExist'
  },
  // 我的首页-我的账号-账号安全管理-修改信息
  umc_changeMemPassword: {
    // mock: true,
    control: 'dyc/common/user/mem/changeMemPassword'
  },
  // 修改密码
  umc_noauth_changeMemPassword: {
    // mock: true,
    control: '/umc/users/signup/updateCustInfoPassword'
  },
  // 我的首页-我的账号-账号安全管理-商品收藏
  common_goodsCollecAbility: {
    // mock: true,
    control: 'dyc/saas/common/user/getGoodsCollectionsPageList'
  },
  // 我的首页-机构与用户管理-企业机构管理
  common_queryOrgList: {
    // mock: true,
    control: 'dyc/saas/common/user/org/qryEnterpriseOrgListPage'
  },
  // 公用应用-运营单位下拉列表
  common_qryOperateDropDwonList: {
    // mock: true,
    control: 'dyc/common/user/org/qryOperateDropDwonList'
  },
  // 我的首页-机构与用户管理-企业机构管理-新增
  common_addEnterpriseOrg: {
    // mock: true,
    control: 'dyc/common/user/org/addEnterpriseOrg'
  },
  // 我的首页-机构与用户管理-企业机构管理-详情
  common_qryEnterpriseOrgDetail: {
    // mock: true,
    control: 'dyc/common/user/org/qryEnterpriseOrgDetail'
  },
  // 我的首页-机构与用户管理-客商企业机构管理-提交是否确认数据有效
  common_exportSupplierReconciliationExcel: {
    // mock: true,
    control: 'dyc/fsc/exportSupplierReconciliationExcel'
  },
  // 我的首页-机构与用户管理-企业机构管理-上传
  common_upload: {
    // mock: true,
    control: 'dyc/appnogateway/common/communal/fileGeneration/upload'
  },
  // 我的首页-机构与用户管理-企业机构管理-上传（未登录）
  common_noauthUpload: {
    // mock: true,
    control: 'dyc/appnogateway/common/communal/noauth/fileGeneration/upload'
  },
  // 我的首页-机构与用户管理-企业机构管理-树形列表
  common_queryEnterpriseOrgTree: {
    // mock: true,
    control: 'dyc/saas/common/user/org/queryEnterpriseOrgTree'
  },
  // 我的首页-机构与用户管理-企业机构管理-树形列表（新）
  common_qryEnterpriseInfoTree: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/qryEnterpriseInfoTree'
  },
  // 我的首页-机构与用户管理-企业机构管理-树形列表查询
  common_queryEnterpriseOrgTreeByPage: {
    // mock: true,
    control: 'dyc/common/user/org/queryEnterpriseOrgTreeByPage'
  },
  // 评级小组设置-选择小组成员-机构搜索
  common_enterpriseInfoTree: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/qryEnterpriseInfoTree'
  },
  // 我的首页-机构与用户管理-企业机构管理-树形列表查询 新
  common_queryInnerEnterpriseOrgTree: {
    // mock: true,
    control: 'dyc/common/user/org/queryInnerEnterpriseOrgTree'
  },
  // 我的首页-机构与用户管理-企业机构管理-停用删除
  common_deleteStartStopEnterpriseOrg: {
    // mock: true,
    control: 'dyc/common/user/org/deleteStartStopEnterpriseOrg'
  },
  // 我的首页-机构与用户管理-企业机构管理-修改
  common_updateEnterpriseOrg: {
    // mock: true,
    control: 'dyc/common/user/org/updateEnterpriseOrg'
  },
  // 我的首页-机构与用户管理-企业机构管理-修改客商
  common_updateEnterpriseOrgAudit: {
    // mock: true,
    control: 'dyc/common/user/org/updateEnterpriseOrgAudit'
  },
  // 我的首页-机构与用户管理-客商企业机构管理-提交是否确认数据有效
  common_selectMemTrade: {
    mock: false,
    control: 'dyc/common/user/mem/selectMemTrade'
  },
  // 我的首页-机构与用户管理-企业用户管理-列表
  common_queryUserList: {
    // mock: true,
    control: 'dyc/saas/common/user/mem/qryMemberListPage'
  },
  common_queryUserListNew: {
    // mock: true,
    control: 'dyc/saas/common/user/qryMemberListPage'
  },
  // 我的首页-机构与用户管理-企业机构管理-树形列表查询
  common_auditOrgList: {
    // mock: true,
    control: 'dyc/saas/common/enterprise/auditOrgList'
  },
  // 我的首页-机构与用户管理-企业用户管理-详情
  common_qryMemberDetail: {
    // mock: true,
    control: 'dyc/common/user/mem/qryMemberDetail'
  },
  // 我的首页-机构与用户管理-企业用户管理-新增
  common_addMember: {
    // mock: true,
    control: 'dyc/common/user/mem/addMember'
  },
  // 我的首页-机构与用户管理-企业用户管理-修改
  common_updateMember: {
    // mock: true,
    control: 'dyc/common/user/mem/updateMember'
  },
  // 我的首页-机构与用户管理-企业用户管理-授权树
  common_authUser: {
    // mock: true,
    control: 'dyc/common/user/authority/user/authUser'
  },
  // 我的首页-机构与用户管理-企业用户管理-授权
  common_authUserCommit: {
    // mock: true,'
    control: 'dyc/common/user/author/authUserCommit'
  },
  // 我的首页-机构与用户管理-企业用户管理-调岗
  common_submitMemChangePozition: {
    // mock: true,
    control: 'dyc/common/user/mem/submitMemChangePozition'
  },
  // 我的首页-机构与用户管理-企业用户管理-停用启用删除
  common_stopUsedInnerEnterpriseUser: {
    // mock: true,
    control: 'dyc/common/user/stopUsedInnerEnterpriseUser'
  },
  // 我的首页-机构与用户管理-企业用户管理-查看调岗历史
  common_queryMemChangePozitionHis: {
    // mock: true,
    control: 'dyc/common/user/mem/queryMemChangePozitionHis'
  },
  // 我的首页-公用应用-供应商签约单列表查询API
  common_getSupSignContractList: {
    // mock: true,
    control: 'dyc/supplier/signContract/getSupSignContractList'
  },
  // 我的首页-公用应用-供应商签约单创建API
  common_addSupSignContract: {
    // mock: true,
    control: 'dyc/supplier/signContract/addSupSignContract'
  },
  // 我的首页-公用应用-供应商签约详情查询API
  common_getSupSignContractDetail: {
    // mock: true,
    control: 'dyc/supplier/signContract/getSupSignContractDetail'
  },
  // 我的首页-公用应用-供应商签约详情查询API
  common_list: {
    // mock: true,
    control: 'fileDownloadPlatform/task/list'
  },
  // 我的首页-公用应用-供应商签约单修改API
  common_modifySupSignContract: {
    // mock: true,
    control: 'dyc/supplier/signContract/modifySupSignContract'
  },
  // 我的首页-公用应用-供应商签约单删除API
  common_deleteSupSignContract: {
    // mock: true,
    control: 'dyc/supplier/signContract/deleteSupSignContract'
  },
  // 我的首页-公用应用-供应商签约单品类列表查询API
  common_getSalesCategoryList: {
    // mock: true,
    control: 'dyc/supplier/signContract/getSalesCategoryList'
  },
  // 我的首页-公用应用-供应商签约已选未选单品类列表查询API
  common_getUccCategoryList: {
    // mock: true,
    control: 'dyc/supplier/signContract/getUccCategoryList'
  },
  // 我的首页-公用应用-供应商签约单确认API
  common_dealSupSignContractConfirm: {
    // mock: true,
    control: 'dyc/supplier/signContract/dealSupSignContractConfirm'
  },
  // 我的首页-机构与用户管理-企业用户管理-重置密码
  common_resetPsw: {
    // mock: true,
    control: 'dyc/common/user/mem/resetPsw'
  },
  // 我的首页-机构与用户管理-企业用户管理-兼职树形列表
  common_qryPartTimeOrgList: {
    // mock: true,
    control: 'dyc/common/user/org/qryPartTimeOrgList'
  },
  // 我的首页-机构与用户管理-企业用户管理-兼职情况
  common_qryPartMemListPage: {
    // mock: true,
    control: 'dyc/common/user/qryPartMemListPage'
  },
  // 我的首页-机构与用户管理-企业用户管理-兼职提交
  common_submitMemPartMem: {
    // mock: true,
    control: 'dyc/common/user/mem/submitMemPartMem'
  },
  // 发票邮寄地址
  common_qryInvoiceAddressListSelf: {
    // mock: true,
    control: 'dyc/saas/common/qryInvoiceAddressListPage'
  },
  // 发票邮寄地址-新增
  umc_addInvoiceAddress: {
    // mock: true,
    control: 'dyc/saas/common/user/addInvoiceAddress'
  },
  // 发票邮寄地址-修改
  umc_updateInvoiceAddress: {
    // mock: true,
    control: 'dyc/saas/common/user/upadteInvoiceAddress'
  },
  // 发票邮寄地址-详情
  umc_qryInvoiceAddressDetail: {
    // mock: true,
    control: 'dyc/saas/common/user/qryInvoiceAddressDetail'
  },
  // 查询机构树列表
  umc_queryEnterpriseOrgTreeList: {
    // mock: true,
    control: 'dyc/saas/common/qryEnterpriseInfoTree'
  },
  // 外部个人-发票邮寄地址-新增
  common_addInvoiceMailAddress: {
    // mock: true,
    control: 'dyc/common/user/addInvoiceMailAddress'
  },
  // 外部个人-发票邮寄地址-修改
  common_updateInvoiceMailAddress: {
    // mock: true,
    control: 'dyc/common/user/updateInvoiceMailAddress'
  },
  // 外部个人-发票邮寄地址-详情
  common_queryInvoiceMailAddressDetails: {
    // mock: true,
    control: 'dyc/common/user/queryInvoiceMailAddressDetails'
  },
  // 我的首页-企业信息管理-外部个人发票信息-分页
  cnnc_queryInvoiceList: {
    // mock: true,
    control: 'dyc/common/user/queryInvoiceList'
  },
  // 企业发票信息 列表
  common_qryEnterpriseInvoiceInfoList: {
    // mock: true,
    control: 'dyc/saas/common/qryAccountInvoiceListPage'
  },
  // 企业账套信息-账套列表查询
  umc_qryEnterpriseAccountList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryEnterpriseAccountList'
  },
  // 工作台关联列表查询
  umc_qryWorkBenchRelList: {
    // mock: true,
    control: 'dyc/common/user/module/qryWorkBenchRelList'
  },
  // 工作台关联列表查询
  umc_qryWorkBenchDisList: {
    // mock: true,
    control: 'dyc/common/user/module/qryWorkBenchDisList'
  },
  // 设置工作台
  umc_dealWorkBenchRel: {
    // mock: true,
    control: 'dyc/common/user/module/dealWorkBenchRel'
  },
  // 常用菜单列表
  umc_qryCommonMenuList: {
    // mock: true,
    control: 'dyc/saas/common/user/module/qryCommonMenuList'
  },
  // 常用全部菜单 支持搜索 按menuid
  umc_qryCommonMenuDisList: {
    // mock: true,
    control: 'dyc/saas/common/user/module/qryCommonMenuDisList'
  },
  // 操作常用设置
  umc_dealCommonMenu: {
    // mock: true,
    control: 'dyc/saas/common/user/module/dealCommonMenu'
  },
  // 申请上架服务单列表查询API
  common_queryApplyForSalePage: {
    // mock: true,
    control: 'dyc/busicommon/commodity/queryApplyForSalePage'
  },
  // 申请上架服务单查看详情
  common_getApplyForSaleWorkOrderDetail: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getApplyForSaleWorkOrderDetail'
  },
  // 申请上架服务单流转API [可用删除]
  common_applyForSaleFlow: {
    // mock: true,
    control: 'dyc/busicommon/commodity/applyForSaleFlow'
  },
  // 申请上架服务单再次提交接口
  common_applyForSaleSecondAdd: {
    // mock: true,
    control: 'dyc/busicommon/commodity/applyForSaleSecondAdd'
  },
  // 申请上架商品清单导入
  common_dealDycApplyForSaleImport: {
    // mock: true,
    control: 'dyc/busicommon/commodity/dealDycApplyForSaleImport'
  },
  // 申请上架查询单品列表
  common_getSkuInfoList: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getSkuInfoList'
  },
  // 申请上架单品关联工单业务API
  common_applyForSaleRelSkuAdd: {
    // mock: true,
    control: 'dyc/busicommon/commodity/applyForSaleRelSkuAdd'
  },
  // 申请上架已关联单品编码列表查询API
  common_getApplyForSaleRelSkuListQry: {
    // mock: true,
    control: 'dyc/busicommon/commodity/getApplyForSaleRelSkuListQry'
  },
  // 成交服务费收取规则-修改页面商品列表查询API
  common_queryItemList: {
    // mock: true,
    control: 'dyc/saas/supplier/noauth/queryItemList'
  },
  // 申请上架-商品类型
  common_querySupplierSaleCategoryListBySupplierId: {
    // mock: true,
    control: 'dyc/contract/querySupplierSaleCategoryListBySupplierId'
  },
  // 工作台-用于待办项查询
  common_qryWaitDoneList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryWaitDoneList'
  },
  // 工作台-商品审批数接口查询
  common_skuApprovalNum: {
    // mock: true,
    control: 'dyc/busicommon/commodity/skuApprovalNum'
  },
  // 工作台-我的售后数量
  common_qryUocAfterServiceManageList: {
    // mock: true,
    control: 'dyc/saas/self/order/qryUocAfterServiceManageList'
  },
  // 工作台-客商管理审批数接口查询
  common_qryWorkbenchStatistics: {
    // mock: true,
    control: 'dyc/saas/common/workbench/qryWorkbenchStatistics'
  },
  // 工作台-协议审批数接口查询
  common_qryApproveCount: {
    // mock: true,
    control: 'dyc/zone/agreement/qryApproveCount'
  },
  // 工作台-待报价询价单数接口查询
  common_inquirySheetStatistic: {
    // mock: true,
    control: 'dyc/mall/commodity/manger/inquirySheetStatistic'
  },
  // 工作台-订单单数接口查询
  common_qrySalOrderList: {
    // mock: true,
    control: 'dyc/saas/self/order/qrySalOrderList'
  },
  // 工作台--买家-我的询盘单 
  common_myInquirySheetStatistic: {
    // mock: true,
    control: 'dyc/mall/commodity/myInquirySheetStatistic'
  },
  // 工作台-用于待办项明细查询
  common_qryWaitDoneDetailList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryWaitDoneDetailList'
  },
  // 工作台-用于待办项设置
  common_dealWaitDoneSet: {
    // mock: true,
    control: 'dyc/saas/common/user/dealWaitDoneSet'
  },
  // 智能客服管理-客服管理查询
  common_qryCsList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryCsList'
  },
  // 智能客服管理-技能组查询
  common_qrySkillGroupList: {
    // mock: true,
    control: 'dyc/common/user/qrySkillGroupList'
  },
  // 智能客服管理-客服角色查询
  common_qryCsRoleList: {
    // mock: true,
    control: 'dyc/saas/common/user/qryCsRoleList'
  },
  // 智能客服管理-人员查询
  common_qryCsWaitMemberList: {
    // mock: true,
    control: 'dyc/common/user/qryCsWaitMemberList'
  },
  // 智能客服管理-新增
  common_dealCustServiceCreate: {
    // mock: true,
    control: 'dyc/saas/common/user/dealCustServiceCreate'
  },
  // 智能客服管理-修改
  common_dealCustServiceEdit: {
    // mock: true,
    control: 'dyc/saas/common/user/dealCustServiceEdit'
  },
  // 智能客服管理-删除
  common_dealCustServiceDelete: {
    // mock: true,
    control: 'dyc/saas/common/user/dealCustServiceDelete'
  },
  // 我的首页-查询分析管理-查询分析
  common_singleAnalysis: {
    // mock: true,
    control: '/dyc/mall/commodity/searchqa/singleAnalysis'
  },
  // 我的首页-查询分析管理-查询分析-获取文件列表
  common_downloadFileList: {
    // mock: true,
    control: '/dyc/mall/commodity/searchqa/downloadFileList'
  },
  // 我的首页-查询分析管理-查询分析-上传文件
  common1_upload: {
    // mock: true,
    control: 'dyc/mall/commodity/searchqa/upload'
  },
  // 我的首页-查询分析管理-查询分析-批量删除
  common_deleteFile: {
    // mock: true,
    control: 'dyc/mall/commodity/searchqa/deleteFile'
  },
  // 重置密码修改
  common_resetsaasPsw: {
    // mock: true,
    control: 'dyc/saas/common/user/resetPsw'
  }
};